import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
`;

export const Body = styled.div`
  max-width: 768px;
  margin: 56px auto 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xl);

  > h1 {
    > svg {
      margin-right: var(--spacing-l);
    }
  }
`;
export const BodyFooter = styled.div`
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: var(--spacing-xxl);

  > h3 {
    margin-bottom: var(--spacing-l);
  }
`;
